import { isEmail } from 'validator';

// export function email() {
//   return (value = '') =>
//     !value || isEmail(value || '')
//       ? undefined
//       : 'Please enter a valid email address';
// }

export function email() {
  return (value = '') => {
    if (Array.isArray(value)) {
      for (const { value } of value) {
        if (!isEmail(value || '')) {
          return 'Please enter a valid email address';
        }
      }
      return undefined;
    }
    if (!value || isEmail(value || '')) {
      return undefined;
    }

    return 'Please enter a valid email address';
  };
}
